import { render, staticRenderFns } from "./model-type-selector.vue?vue&type=template&id=4245b4d6&"
import script from "./model-type-selector.vue?vue&type=script&lang=js&"
export * from "./model-type-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports